module.exports = __webpack_public_path__ + "static/media/Item_Weapon_AWM_C.3fb0b120.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Main/Item_Weapon_AWM_C.png
// module id = ./src/assets/item/Weapon/Main/Item_Weapon_AWM_C.png
// module chunks = 0